import { exploreSchemaItemList } from '@/templates/Landing/seoLandings/exploreSchema';
import { ENV } from '@/constants';

export const schemaObject_AiBratzGenerator = {
	'@context': 'https://schema.org',
	'@graph': [
		{
			'@type': 'WebPage',
			'@id': 'https://liftapp.ai/ai-bratz-generator',
			name: 'AI Bratz Generator - Custom Bratz Doll Maker - AI Creator Online | Lift',
			description:
				"Create your own Bratz character online with Lift's AI Bratz Creator. No watermark. Upload a photo, apply a Bratz doll filter, and get your Bratz avatar — perfect for social media.",
			url: 'https://liftapp.ai/ai-bratz-generator',
			image: 'https://liftapp.ai/seo-image.webp',
			mainEntity: [
				{ '@id': 'https://liftapp.ai/ai-bratz-generator#product' },
				{ '@id': 'https://liftapp.ai/ai-bratz-generator#howto' },
				{ '@id': 'https://liftapp.ai/ai-bratz-generator#benefits' },
				{ '@id': 'https://liftapp.ai/ai-bratz-generator#faq' },
				{ '@id': 'https://liftapp.ai/ai-bratz-generator#why-lift' },
				{ '@id': 'https://liftapp.ai/ai-bratz-generator#explore-tools' },
				{ '@id': 'https://liftapp.ai/ai-bratz-generator#all-in-one' },
			],
		},
		// product
		{
			'@type': 'Product',
			'@id': 'https://liftapp.ai/ai-bratz-generator#product',
			name: 'AI Bratz Generator Online',
			description:
				'Turn yourself into a stylish Bratz doll in seconds! No design skills needed. Perfect for sharing on Instagram, TikTok, or anywhere you want to show off your unique style and personality. Create and go viral!',
			url: 'https://liftapp.ai/ai-bratz-generator',
			fileFormat: ['image/jpeg', 'image/png', 'image/webp'],
			memoryRequirements: 'Max file size: 20MB',
			brand: {
				'@type': 'Brand',
				name: 'Lift',
			},
			aggregateRating: {
				'@type': 'AggregateRating',
				ratingValue: '4.8',
				reviewCount: 130000,
				bestRating: '5',
				worstRating: '1',
			},
			interactionStatistic: [
				{
					'@type': 'InteractionCounter',
					interactionType: { '@type': 'InstallAction' },
					userInteractionCount: 13000000,
				},
			],
		},
		// howto
		{
			'@type': 'HowTo',
			'@id': 'https://liftapp.ai/ai-bratz-generator#howto',
			name: 'How it works',
			step: [
				{
					'@type': 'HowToStep',
					position: 1,
					name: 'Upload your image',
					text: 'Select a photo from your gallery or snap one directly in the app',
				},
				{
					'@type': 'HowToStep',
					position: 2,
					name: 'AI creates your Bratz avatar',
					text: 'Instantly convert your photo into a custom Bratz doll with signature big eyes, glossy lips, and fierce style',
				},
				{
					'@type': 'HowToStep',
					position: 3,
					name: 'Apply the transformation',
					text: 'Let AI reimagine your photo in seconds',
				},
				{
					'@type': 'HowToStep',
					position: 4,
					name: 'Download and share',
					text: 'Download your image or publish it straight to your social feeds',
				},
			],
		},
		// benefit
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/ai-bratz-generator#benefits',
			name: 'Who can benefit from AI Bratz Generator?',
			description:
				"Lift's AI Bratz Generator is perfect for Y2K aesthetic lovers, social media users, content creators, and friends who want to create trendy Bratz-style avatars and content.",
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Y2K and Bratz-era fans recreating their glam doll alter egos',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Social media users crafting bold pfps, banners, or Reels covers',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Content creators launching trendy challenges or filters',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Besties making matching Bratz squads for group chats',
				},
				{
					'@type': 'ListItem',
					position: 5,
					name: 'Fashion lovers designing moodboards or inspo cards',
				},
				{
					'@type': 'ListItem',
					position: 6,
					name: 'Event hosts adding Bratz-style invites, stickers, or party favors',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/benefits.3da6de53.webp',
				name: 'AI Bratz Doll Creator',
				description:
					'Example of how Lift AI Bratz Generator creates custom Bratz-style avatars with signature big eyes, glossy lips, and fierce fashion.',
			},
		},

		// faq
		{
			'@type': 'FAQPage',
			'@id': 'https://liftapp.ai/ai-bratz-generator#faq',
			mainEntity: [
				{
					'@type': 'Question',
					name: 'What is Lift AI Bratz Generator?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Lift AI Bratz Generator is an online tool that transforms your photos into custom Bratz doll avatars — complete with signature big eyes, glossy lips, bold makeup, and fierce fashion. Perfect for profile pictures, social media posts, and expressing your inner bratty style.',
					},
				},
				{
					'@type': 'Question',
					name: 'How does Lift AI Bratz Generator work?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Our AI analyzes your photo with deep learning, keeps your facial features recognizable, and reimagines you as a Bratz doll with signature oversized eyes, plump lips, trendy outfits, and that iconic Y2K aesthetic. Everything is automatic — no manual editing or design skills needed.',
					},
				},
				{
					'@type': 'Question',
					name: 'Can I create a Bratz-style character with any photo?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Yes. Lift works with any portrait photo — selfies, professional shots, or casual pics. The AI adapts to your unique features and creates custom transformations inspired by classic Bratz-style aesthetics.',
					},
				},
				{
					'@type': 'Question',
					name: 'Can I download the results without a watermark?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: "Absolutely. All images generated or edited in Lift can be exported without watermark when you're on the Pro plan. Download them in high-res PNG or JPG — ready for social media, Discord pfp, group chat avatars, or anywhere you want to show off your Bratz style.",
					},
				},
			],
		},

		// why lift
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/ai-bratz-generator#why-lift',
			name: "Why Lift's AI Bratz Generator stands out",
			description:
				"Lift's AI Bratz Generator combines professional-grade AI, ease of use, and affordability — making it a trusted choice for millions of users worldwide.",
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'High-quality results',
					description:
						'AI-powered technology delivers professional-grade visuals every time',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Intelligent rendering',
					description:
						'AI tailors the effect to the scene and subject for optimal results',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Cross-platform support',
					description: 'Available on iOS, Android, and Web for seamless access',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Budget-friendly',
					description:
						'Save on costly designers with an affordable and intuitive tool',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/whyUse.ae83a89c.webp',
				name: 'Bratz Avatar Maker',
				description:
					"Comparison of Lift's AI Bratz Generator benefits — high-quality results, intelligent rendering, multi-platform access, and cost savings.",
			},
		},
		// explore
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/ai-bratz-generator#explore-tools',
			name: 'Explore the AI tools',
			description:
				'A curated list of AI-powered tools for image generation, enhancement, background removal, and more – all available on Lift.',
			itemListOrder: 'Unordered',
			...exploreSchemaItemList,
		},

		{
			'@type': 'SoftwareApplication',
			'@id': 'https://liftapp.ai/ai-bratz-generator#all-in-one',
			name: 'Try Lift – AI Content Creation Tools',
			description:
				'Your all-in-one tools to create, edit, and elevate your content. Create stunning content with AI tools, templates, and editing features effortlessly.',
			operatingSystem: 'iOS, Android, Web',
			applicationCategory: 'MultimediaApplication',
			url: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
			applicationSubCategory: 'Content Creation',
			publisher: {
				'@type': 'Organization',
				name: 'Lift',
				url: 'https://liftapp.ai',
			},
			potentialAction: [
				{
					'@type': 'ViewAction',
					name: 'Open Web App',
					target: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
				},
			],
		},

		{
			'@type': 'BreadcrumbList',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Home',
					item: 'https://liftapp.ai',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'AI Bratz Generator',
					item: 'https://liftapp.ai/ai-bratz-generator',
				},
			],
		},
	],
};
